import { connect } from "react-redux";
import { RoomsComponent } from "./RoomsComponent";
import * as roomActions from "../actions";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { setWarningMessage } from "../../messages/actions";
import {
  syncRoomGroupsAndRooms,
  getSyncUser
} from "../../synchronization/actions";
import { isSynchronizing, isAdmin } from "../../users/selectors";
import { translate } from "react-i18next";
import { getRoomGroups } from "../groups/actions";
class RoomsContainer extends Component {
  constructor() {
    super();
    this.state = { isOpenModal: false, selected: undefined };
    this.toggleModal = this.toggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  componentDidMount() {
    if (this.props.rooms.length === 0) {
      this.props.getRooms();
    }

    if (this.props.roomGroups.length === 0) {
      this.props.getRoomGroups();
    }

    if (this.props.isKWHotelUser) {
      this.props.getSyncUser();
    }
  }

  toggleModal(room) {
    this.setState(prevState => ({
      isOpenModal: !prevState.isOpenModal,
      selected: room
    }));
  }

  onSubmit(room) {
    console.log(room);
    if (!room.name) {
      this.props.setWarningMessage("Name can't be empty");
      return;
    }
    if (room.floor == undefined) {
      this.props.setWarningMessage("Floor can't be empty");
      return;
    }
    if (!room.roomGroupId) {
      this.props.setWarningMessage("Room group can't be empty");
      return;
    }
    if (room.roomId) {
      this.props.editRoom(room);
    } else {
      this.props.addRoom(room);
    }
    this.toggleModal();
  }
  render() {
    return (
      <RoomsComponent
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        toggleModal={this.toggleModal}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    rooms: state.rooms.data,
    roomGroups: state.roomGroups.data,
    roomGroupsPhase: state.roomGroups.phase,
    roomsPhase: state.rooms.phase,
    isAdmin: isAdmin(state),
    isKWHotelUser: isSynchronizing(state)
  };
};
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      ...roomActions,
      setWarningMessage,
      syncRoomGroupsAndRooms,
      getSyncUser,
      getRoomGroups
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(RoomsContainer));



// WEBPACK FOOTER //
// ./src/rooms/RoomsList/index.js